<template>
	<!--	:name="vpEtikett"-->
	<!-- '#default' nedan = 'v-slot:default' = nya sättet att sätta 'slot-scope' och kallas 'slot props' (slotProps): -->
	<validation-provider ref="validationProvider"
		tag="div"
		mode="eagerMedBlurOchDebounce"
		:rules="vpValidationRules"
		#default="{ valid, errors, failedRules, flags }"
		class="_eui-form_radiogrupp_validation-provider"
	>
		<div
			class="_eui-form_radiogrupp"
			:class="[ vpClass, {
				'-obligatorisk':skaMarkerasSomObligatorisk,
				'-readonly':vpReadOnly,
				'-osynlig':skaVaraOsynlig,
				'-invalid':flags.validated && !valid,
			}]"
			:style="vpStyle"
			:disabled="skaVaraInaktiverad"
		>
			<!-- ####### Ev titel (ovanför gruppen): -->

			<div v-if="vpEtikett"
				:title="vpTooltip"
				class="_eui-form_radiogrupp_etikett"
				:class="{
					'-readonly':vpReadOnly,
				}"
				v-html="vpEtikett + (vpEtikett.endsWith('?') ? '' : ':')"
			></div>

			<!-- ####### Radioknapparna: -->

			<div v-for="(alt, altIndex) in vpRadiogruppConfig.alternativ" :key="altIndex"
				class="_eui-form_radioknapp"
				:class="{ '-indragen':vpEtikett }"
			>

				<!--
					– VeeValidate: The fields being validated *must have a v-model* so the component can correctly identify the element/component being validated.
					– Input Groups (Checkbox/Radio): Like radio inputs and (sometimes) checkboxes, some inputs behave as a single input entity. You can wrap a whole group of inputs given that they have the same v-model in a single ValidationProvider component.
				-->
				<!--v-model.lazy="innerChecked" -->
				<!--	:title="vpTooltip"-->
				<input ref="inputelementArray"
					:id="altUniktId(altIndex)"
					type="radio"
					:name="uniktId + '-name'"
					:value="alt.varde"
					:checked="innerValue === alt.varde"
					:autofocus="vpAutofocus && altIndex === 0"
					:disabled="alt.disabled || skaVaraInaktiverad || vpReadOnly"
					:class="{
						'-readonly':vpReadOnly,
					}"
					@keydown.enter="onEnterTryckt()"
					@keydown.esc="onEscTryckt()"

					v-model="innerValue"

					v-bind="$attrs"
					v-on="inputListeners"
				>

				<label
					:for="altUniktId(altIndex)"
					class="_eui-form_radioknapp_etikett"
					:class="{
						'-readonly':vpReadOnly,
					}"
					v-html="alt.text + '&nbsp;'"
				></label>

			</div>


			<!-- ####### Valideringstext: -->

			<!--<transition name="el-zoom-in-left">-->
				<div class="_eui-form_radiogrupp_feltext">
					<div class="ellipsis" v-html="errors[0]">
						<!--{{ errors[0] }}-->
					</div>
				</div>
			<!--</transition>-->

		</div>
	</validation-provider>
</template>



<script>
//#####################################################################################

	import Vue from 'vue';
	import { euiLifecycleStatusesMixin } from 'v-mixins/euiLifecycleStatusesMixin';
	import { ValidationProvider } from 'vee-validate';
	import euiFormClasses from 'v-components/classes/euiFormClasses';

	import VeeValidateInstanceMedRattOptions from 'VeeValidateInstanceMedRattOptions';		
	VeeValidateInstanceMedRattOptions.runOnce();		// Kör funktionen om den inte redan körts!

	// Gemensam för alla sådana här komponenter på en sida, vilket är precis det vi vill:
	let uniktIdCounter = 0;


	export default {

		name: 'eui-form-radiogrupp',

		mixins: [ euiLifecycleStatusesMixin ],

		components: {
			'validation-provider': ValidationProvider,
		},

		props:
		{
			// must be included in props
			value: {
				//type: null,

				// På prov för att både tillåta int- och sträng-värden:
				//// String + "" nedan för att den ska valideras korrekt (vid "required"):
				//type: String,
				//default: ''		
				type: [ String, Number ]
			},

			vpRadiogruppConfig: {
				type: [euiFormClasses.radiogruppConfig],
				required: true,
			},

			vpAutofocus: {
				type: Boolean,
				default: false,
			},

			vpEtikett: {			// Får innehålla HTML.
				type: String,
				default: null,
			},

			vpIndikeraInteObligatorisk: {
				type: Boolean,
				default: false,
			},

			vpValidationRules: {
				type: [Object,String],
				default: '',
			},

			vpAccessKey: {
				type: String,
				default: null
			},
			vpTooltip: {
				type: String,			// Får innehålla HTML.
				default: null
			},

			vpReadOnly: {
				type: Boolean,
				default: false,
			},
			vpInaktiverad: {
				type: Boolean,
				default: false,
			},
			vpOsynlig: {
				type: Boolean,
				default: false,
			},

			vpClass: {
				type: String,
				default: null
			},
			vpStyle: {
				type: String,
				default: null
			},
		},

		data() {
			return {
				uniktId: 'eui-form-radiogrupp-unikt-' + (++uniktIdCounter),
				innerValue: undefined,
			};
		},

		inheritAttrs: false,		// Attribut på komponenten ärvs inte till själva *komponentens* rot-element, utan ist till input-elementet, se template ovan. (Gäller *inte* class- och style-attributen!)

		computed: {

			inputListeners() {
				//var vm = this;

				// `Object.assign` merges objects together to form a new object
				return Object.assign({},

					// We add all the listeners from the parent
					this.$listeners,

					// Then we can add custom listeners or override the
					// behavior of some listeners.
					{
						// This (these?!) ensures that the component works with v-model. (Detta gäller inte riktigt längre, då vi inte längre emittar rätt värde.):

						// Enda syftet med denna är att förhindra Vues interna hantering av v-model, dvs att eventet input initierar att värdet, som i komponenters eventhanterare är *själva eventet*, inte event.value eller, som i fallet med radioknapp, event.checked, uppåt.
						// Utan denna hantering så emittas två events:
						// 1. Input, event
						// 2. Input, value
						// Den första av dessa måste bort eftersom annars klagar Vue på att värdet för propertyn 'value' inte är en sträng. Det är dessutom ett event som är onödigt/fel i övrigt:
						input(event) {
						},
					}
				);
			},


			arRequired() {
				return (!this.vpReadOnly && !this.skaVaraInaktiverad && !!this.vpValidationRules && !!(this.vpValidationRules.indexOf('required') !== -1));
			},

			skaMarkerasSomObligatorisk() {
				return this.arRequired && !this.vpIndikeraInteObligatorisk && (this.innerValue === '' || !this.innerValue);
			},

			skaVaraOsynlig() {
				return (this.vpOsynlig || !this.lifecycleStatuses.mixinMountedHasOccured);
			},

			skaVaraInaktiverad() {
				return (this.vpInaktiverad || !this.lifecycleStatuses.mixinMountedHasOccured);
			},
		},

		watch: {
			// Handles internal model changes.
			innerValue(nyttVarde, tidigareVarde) {
				this.$emit('input', nyttVarde);
			},

			// Handles external model changes.
			value(nyttVarde, tidigareVarde) {
				this.innerValue = nyttVarde;
			},

			vpReadOnly(nyttVarde, tidigareVarde)
			{
				if (!nyttVarde)
				{
					// Om den ändrats från read-only –> ändringsbar:
					// Sätt ev autofocus:
					this.sattEventuellAutofocus();
				}
			},
		},

		methods: {
			altUniktId(index) {
				return this.uniktId + '-alt-' + index;
			},

			onEnterTryckt()
			{
				this.$emit('enter-tryckt');
			},

			onEscTryckt() {
				this.$emit('esc-tryckt');
			},

			sattEventuellAutofocus()
			{
				// Sätt ev autofocus:
				if (this.vpAutofocus)
				{
					// Invänta, så att ev reaktiva ändringar (här, att inputelementet blir fokuserbart) hinner slå igenom först:
					Vue.nextTick(function () {
							this.$refs.inputelementArray[0]			// 0 = första radioknappen i gruppen. Obs! Ska korrelera med sättningen av autofocus-attributet i template!
								.focus();
						}
						, this	// Vue.nextTick 'this' context.
					);
				}
			},
		},

		//== Lifecycle hooks  ================================================================================================================

		created() {
			//if(this.value) {
				this.innerValue = this.value;
			//}
		},

		mounted() {

			this.$nextTick(function () {
				// Sätt ev autofocus:
				this.sattEventuellAutofocus();
			});
		},

	}
</script>
